import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

import { Button } from "scmp-app/components/common/button";

export const StyledButton = styled(Button)`
  display: flex;
  flex-direction: row;

  inline-size: fit-content;
  margin-inline: auto;
  padding-block: 8px;
  padding-inline: 12px;

  color: #2c4692;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  text-transform: uppercase;

  border: 1px solid #2c4692;
  border-radius: 100px;

  background-color: #ffffff;
`;
